export class Paginator {
    constructor() { }
    public registros: number = 10;
    public pagina: number = 1;
    public collectionSize: number = 0;
    public lastPage: number = 0;
    public filtroPaginas: any[] = [
        { id: 1, valor: '5', nome: '05 itens por páginas' },
        { id: 2, valor: '10', nome: '10 itens por páginas' },
        { id: 3, valor: '25', nome: '25 itens por páginas' },
        { id: 4, valor: '50', nome: '50 itens por páginas' }
    ]

    public get query() {
        let pageQuery = this.pagina - 1;
        let pageSizeQuery = this.registros;
        return `?pagina=${pageQuery}&registros=${pageSizeQuery}`;
    }

    public toBody(): any {
        return {
            pageNumber: this.pagina - 1, // API espera zero-based
            pageSize: this.registros
        };
    }

    public get queryUser() {
        let pageQuery = this.pagina;
        let pageSizeQuery = this.registros;
        return `?pagina=${pageQuery}&registros=${pageSizeQuery}`;
    }
}
